import axios from '@/api/config';

const certificate = {
  getCertificateById(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/getCertificateById/` + data, {});
  },
  getCertificateDetail(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/getCertificateDetail`, {params: data});
  },
  getCertificate(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/getCertificate`, {params: data});
  },
  getCertificateList(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/getCertificateList`, {params: data});
  },
  getCertificateTree(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/getCertificateTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/certificate/pageList`, data);
  },
  addCertificate(data) {
    return axios.post(`${process.env.BASE_URL}/certificate/addCertificate`, data);
  },
  updateCertificate(data) {
    return axios.put(`${process.env.BASE_URL}/certificate/updateCertificate`, data);
  },
  deleteCertificate(data) {
    return axios.delete(`${process.env.BASE_URL}/certificate/deleteCertificate`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/certificate/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/certificate/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/certificate/active`, data);
  },
}

export default certificate;



// WEBPACK FOOTER //
// ./src/api/certificate.js